// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IUnappliedFundsByOrganizationDto } from './IUnappliedFundsByOrganizationDto';
import {
    IUnappliedFundsByOrganizationDtoFromJSON,
    IUnappliedFundsByOrganizationDtoFromJSONTyped,
    IUnappliedFundsByOrganizationDtoToJSON,
    IUnappliedFundsByOrganizationDtoToJSONTyped,
} from './IUnappliedFundsByOrganizationDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageUnappliedFundsByOrganizationDto
 */
export interface IPageUnappliedFundsByOrganizationDto {
    /**
     * 
     * @type {number}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IUnappliedFundsByOrganizationDto>}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    content?: Array<IUnappliedFundsByOrganizationDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageUnappliedFundsByOrganizationDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageUnappliedFundsByOrganizationDto interface.
 */
export function instanceOfIPageUnappliedFundsByOrganizationDto(value: object): value is IPageUnappliedFundsByOrganizationDto {
    return true;
}

export function IPageUnappliedFundsByOrganizationDtoFromJSON(json: any): IPageUnappliedFundsByOrganizationDto {
    return IPageUnappliedFundsByOrganizationDtoFromJSONTyped(json, false);
}

export function IPageUnappliedFundsByOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageUnappliedFundsByOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IUnappliedFundsByOrganizationDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageUnappliedFundsByOrganizationDtoToJSON(json: any): IPageUnappliedFundsByOrganizationDto {
    return IPageUnappliedFundsByOrganizationDtoToJSONTyped(json, false);
}

export function IPageUnappliedFundsByOrganizationDtoToJSONTyped(value?: IPageUnappliedFundsByOrganizationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IUnappliedFundsByOrganizationDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

